import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, setToken, getToken, setWhatsapp } from "../lib/api";

const Ctx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [config, setConfig] = useState(null);
  const [buyOpen, setBuyOpen] = useState(false);
  const [paywall, setPaywall] = useState("");
  const [impersonating, setImpersonating] = useState(() => !!localStorage.getItem("namo_admin_token"));

  const refresh = useCallback(async () => {
    if (!getToken()) return setUser(false);
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setToken(null);
      setUser(false);
    }
  }, []);

  useEffect(() => {
    const loadConfig = (tries = 0) =>
      api.get("/config").then(({ data }) => { setConfig(data); setWhatsapp(data.whatsapp); })
        .catch(() => tries < 5 && setTimeout(() => loadConfig(tries + 1), 1500 * (tries + 1)));
    loadConfig();
    const onPaywall = (e) => { setPaywall(e.detail || "paywall"); setBuyOpen(true); };
    window.addEventListener("namo:paywall", onPaywall);
    // Skip /me while returning from Google OAuth; AuthCallback exchanges session_id first.
    if (window.location.hash?.includes("session_id=")) return;
    refresh();
    return () => window.removeEventListener("namo:paywall", onPaywall);
  }, [refresh]);

  const impersonate = async (uid) => {
    const { data } = await api.post(`/admin/users/${uid}/impersonate`);
    localStorage.setItem("namo_admin_token", getToken());
    setToken(data.token);
    setImpersonating(true);
    window.location.href = "/";
  };
  const exitImpersonation = () => {
    setToken(localStorage.getItem("namo_admin_token"));
    localStorage.removeItem("namo_admin_token");
    setImpersonating(false);
    window.location.href = "/admin";
  };

  const google = useCallback(async (session_id) => {
    const { data } = await api.post("/auth/google/session", { session_id });
    setToken(data.token);
    setUser(data.user);
    return data.user;
  }, []);

  const auth = async (path, body) => {
    const { data } = await api.post(`/auth/${path}`, body);
    setToken(data.token);
    setUser(data.user);
    return data.user;
  };
  const logout = () => {
    localStorage.removeItem("namo_admin_token");
    setImpersonating(false);
    setToken(null);
    setUser(false);
  };

  return (
    <Ctx.Provider value={{ user, config, refresh, auth, google, logout, buyOpen, setBuyOpen: (v) => { setBuyOpen(v); if (!v) setPaywall(""); }, paywall, impersonating, impersonate, exitImpersonation }}>{children}</Ctx.Provider>
  );
}

export const useAuth = () => useContext(Ctx);
